<template>
  <a-form :form="form" @submit="handleSubmit">
    <vx-card title="دسترسی ها">
      <ASpin type="loading" :spinning="loading">
        <div class="grid grid-col-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 md:gap-2 xl:grid-cols-2 lg:gap-4 xl:gap-4">
            <a-form-item label="سطح کاربر">
              <a-select
                v-decorator="['user_type', { initialValue:null,rules: [{ required: true, message: 'لطفاسطح دسترسی را انتخاب کنید' }] }]" @change="selectChange">
                <a-select-option v-for="item in userTypes" :value="item.id">
                  {{ item.value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          <a-form-item label="نام" has-feedback v-if="showName">
            <input class="ant-input"
                v-decorator="['name', { rules: [{ required: true, message: 'لطفا مقدار را وارد کنید' }] }]"
                autocomplete="off"
            />
          </a-form-item>
            <a-form-item label="نقش ها">
              <a-tree style="direction: rtl"
                    v-model="rid"
                    checkable
                    default-expand-all
                    :tree-data="treeData"
              />

              <!--                    :replace-fields="replaceFields"-->
<!--              :auto-expand-parent="autoExpandParent"-->
            </a-form-item>
        </div>
        <a-button type="primary" html-type="submit">
           ثبت اطلاعات
        </a-button>
      </ASpin>
    </vx-card>
  </a-form>
</template>

<script>

  import axios from '@/axios'

  export default {
    name: "Access",
    data() {
      return {
        form: this.$form.createForm(this, {name: 'coordinated'}),
        treeData:undefined,
        userTypes: undefined,
        // autoExpandParent: false,
        rid: [],
        /*replaceFields: {
          children: 'child',
          title: 'title'
        },*/
        // keyId: null,
        getDataUserType:null,
        showName:false,
        loading:false
      }
    },

    methods: {
      async getUserTypes(){
        try{
          this.loading = true
          const {data} = await axios.get('/permission/type')
          if(this.$getAccess("permission.create")){
            data.push
            ({
              id: "new",
              value: "افزودن کاربر جدید"
            })
          }
          this.userTypes = Object.values(data)
        }catch (e) {
          console.log("errr:",e)
        }finally {
          this.loading = false
        }
      },
      async getPermission() {
        try{
          this.loading = true
          const {data} = await axios.get('/permission')
          this.treeData = Object.values(data)
        }catch (e) {
          console.log("errr:",e)
        }finally {
          this.loading = false
        }
      },
      handleSubmit(e) {
        e.preventDefault();
        this.form.validateFields(async (err, values) => {
          if (!err) {
            try {
              this.loading = true
              values.rid = this.rid
              if(values.user_type == "new"){
                values.user_type = values.name
              }
              await axios.post('/permission',values)
              if (values.user_type == JSON.parse(localStorage.getItem('userInfo')).user_type)
                await this.$store.dispatch("access/setPermissions", values.rid)
              this.$ntSet()
              setTimeout(()=>{
                window.location.reload()
              },500)
            } catch (e) {
              this.$ntSetError(e)
            } finally {
              this.loading =false
            }
          }
        });
      },
      async selectChange(id){
        try{
          this.loading = true
          if (id !== "new") {
            this.showName = false
            let {data: {rid}} = await axios.get(`/permission/show/${id}`)
            this.rid = Object.values(rid)
          }
          else{
            this.showName = true
          }
        }catch (e) {
          console.log("errr:",e)
        }finally {
          this.loading = false
        }
      }
    },
    computed: {
      data(){
        console.log(this.$store.state.access.access_id,'hgghgh')
        return this.$store.state.access.access_id
      }
    },
    async mounted() {
      this.form.setFieldsValue({user_type:1})
      await this.selectChange(1)
    },
    async created(){
      await this.getPermission()
      await this.getUserTypes()
    }
  }
</script>


<!--<style>
  [dir=rtl] .ant-tree-checkbox-inner::after{
    right: 55%;
    top: 35%;
    border-left: 0 !important;
    -webkit-transform: rotate(-45deg) scale(0) translate(50%, -50%);
    transform: rotate(-45deg) scale(0) translate(50%, -50%);
  }
  [dir=rtl] .ant-tree-checkbox-checked .ant-tree-checkbox-inner::after{
    border-left: 0 !important;
    border-right: 2px solid #fff;
  }
  [dir=rtl] .ant-tree-checkbox-checked .ant-tree-checkbox-inner::after {
    border-left: 0 !important;
    border-right: 2px solid #fff;
    -webkit-transform: rotate(-45deg) scale(1) translate(50%, -50%);
    transform: rotate(25deg) scale(1) translate(50%, -50%);
  }
</style>-->
